<template>
  <a :href='relativeLink(story.url)' :target='target' class="story-wrap" v-if='hasTag(story)'>
    <article>
      <play class="play" paused='false' />
      <div class="info">
        <nav class="metadata">
          <h4 class="author" v-html='story.strings.author' />
          <h5 class="date" v-if='story.strings.date' v-html='formattedDate(story.strings.date, "mediumDate")' />
          <duration v-if='story.strings.story_audio' :audio='story.uri + "/" + firstOfArrayOrString(story.strings.story_audio)' />
        </nav>
        <h3 class="title" v-html='story.strings.title' />
        <summary class="desc" v-html='story.strings.text' />
      </div>
      <heart cookie='pennMedHeartedStories' :uid='story.uid' :hearted.sync='hearted' v-if='!kiosk'/>
    </article>
  </a>
</template>

<script>
import mixins from '.././mixins.js';
export default {
  props: ['story', 'target', 'filtered'],
  mixins: [mixins],
  data: function() {
    return {
      hearted: false,
    }
  },
  methods: {
    hasTag: function(story) {
      if(this.filtered != 'My Story Collection') {
        return this.filtered  ? story.strings.story_tags.split(/,\s*/).indexOf( this.filtered ) > -1 : true;
      } else {
        return this.hearted;
      }
    }
  }
}
</script>

<style scoped>

a.story-wrap {
  display: block;
  max-width: none;
  padding: 1rem 0;
  border-top: var(--thinline);
}

article {
  display: flex;
  flex-direction: row;
  gap: 2em;
  justify-content: space-between;
  vertical-align: top;
}

.play {
  width: 4rem;
  height: 4rem;
  flex-grow: 1;
}

.info {
  flex-grow: 3;
  flex-basis: 70%;
}

.heart {
  flex-grow: 1;
  flex-basis: 1.5rem;
}

nav.metadata {
  /*font-size: 0.8rem;*/
  color: #8eccd1;
  position: relative;
}

.info .desc {
  font-size: 0.8rem;
  line-height: 1.25;
}

time.duration {
  position: absolute;
  top: 0;
  right: 0;
}

</style>

<style>
.cls-1{fill: var(--mint);}
.cls-2{fill: var(--blue);}

svg.play {
  width: 4em;
}
</style>
